import Browser from '@mindful-web/marko-web/browser';
import RevealAd from '@mindful-web/marko-web-reveal-ad/browser';
import Global from '@pmmi-media-group/package-global/browser';

RevealAd(Browser);
Global(Browser);

export default Browser;
